/**
 * スクロール連動リビール演出
 *
 * data-reveal 属性を持つ要素が画面内に入ったタイミングで .is-visible を付与し、
 * CSS 側（_reveal.scss）のアニメーションを発火させる。
 */

const REVEAL_SELECTOR = "[data-reveal]";

/**
 * リビールの初期状態（非表示）を適用してよいことをCSSへ伝えるフラグ。
 * JSが無効・実行失敗した場合に要素が隠れたままになるのを防ぐため、
 * CSS側はこのクラスを起点にしている。DOMContentLoadedより前に呼ぶ。
 */
export const markRevealReady = () => {
  document.documentElement.classList.add("is-reveal-ready");
};

export const initReveal = () => {
  const targets = [...document.querySelectorAll(REVEAL_SELECTOR)];
  if (!targets.length) return;

  // 動きを減らす設定の場合は演出を挟まず、最初から表示状態にする
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    targets.forEach((target) => target.classList.add("is-visible"));
    return;
  }

  /** @type {IntersectionObserver[]} */
  const observers = [];

  const reveal = (target) => {
    if (target.classList.contains("is-visible")) return;

    target.classList.add("is-visible");
    // 一度表示したら監視を解除（再生は1回だけ）
    observers.forEach((observer) => observer.unobserve(target));
  };

  const handleEntries = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) reveal(entry.target);
    });
  };

  // 画面下端から少し入った位置で発火させ、見え始めと同時に動き出すのを避ける
  observers.push(
    new IntersectionObserver(handleEntries, {
      root: null,
      rootMargin: "0px 0px -12% 0px",
      threshold: 0,
    }),
  );

  // 上の監視は下端を削っているため、ページ末尾の要素が発火しないままになる。
  // 「画面内に全体が収まったら発火」を保険として併用する。
  observers.push(
    new IntersectionObserver(handleEntries, {
      root: null,
      threshold: 1,
    }),
  );

  targets.forEach((target) => {
    observers.forEach((observer) => observer.observe(target));
  });
};
